import React, { useState, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSort } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import DashboardContext from "../../../../contexts/DashboardContext";
import Loading from "../../../../components/Shared/ResourceIndex/Loading";
import AppContext from '../../../../contexts/AppContext';
import userApi from '../../../../utils/api/user';
import TenantFeatureContext  from '../../../../contexts/TenantContext';
import { useTenantRedirect } from '../../../../hooks/useTenantRedirect';
import MFAVerificationModal from '../../../Shared/MFAVerificationModal';



const ProjectList = ({selectedProjects,setSelectedProjects,isPhone = false,selectMode = false,phoneSort = 'site'}) => {
  const [clientIsAscending, setClientIsAscending] = useState(true)
  const [siteIsAscending, setSiteIsAscending] = useState(true)  
  const appContext = useContext(AppContext);
   
  const {
    redirectToTenant,
    showMFAModal,
    mfaData,
    handleMFAVerificationSuccess,
    handleMFAModalClose,
    authStore,
  } = useTenantRedirect();
 
  const user = appContext.get('user');
  const { displayStatsForMP, isLoadingForMP, setDisplayStatsForMP } = useContext(DashboardContext)
  const tenantFeatureContext = useContext(TenantFeatureContext);


  //SORT
  const sortBySiteName = () => {
    const updatedList = displayStatsForMP.sort((a, b) => {
      let A = a.project.name.toString().toLowerCase()

      let B = b.project.name.toString().toLowerCase()

      if (siteIsAscending === true) {
        setSiteIsAscending(!siteIsAscending)

        return A > B ? -1 : 1 // descending
      }

      else {
        setSiteIsAscending(!siteIsAscending)

        return A > B ? 1 : -1 //ascending
      }
    })

    setDisplayStatsForMP(updatedList)
  }
  
  const sortByClientName = () => {
    const updatedList = displayStatsForMP.sort((a, b) => {
      let A = a.project.client.name.toString().toLowerCase()

      let B = b.project.client.name.toString().toLowerCase()

      if (clientIsAscending === true) {
        setClientIsAscending(!clientIsAscending)

        return A > B ? -1 : 1 // descending
      }

      else {
        setClientIsAscending(!clientIsAscending)

        return A > B ? 1 : -1 //ascending
      }
    })

    setDisplayStatsForMP(updatedList)
  }


  const handleRedirect = (ele) => {
    const redirectPath = `/divisions/${ele.division.id}/projects/${ele.project_id}/inspections`;

    redirectToTenant(ele.division.tenant_id, redirectPath);
  };

  const handleCheckboxChange = (project) => {
    setSelectedProjects(prevSelectedProjects =>
      prevSelectedProjects.includes(project)
        ? prevSelectedProjects.filter(selectiedProject => selectiedProject.id !== project.id)
        : [...prevSelectedProjects, project]
    );
  };

  const mfaModal = mfaData && (
    <MFAVerificationModal
      show={showMFAModal}
      handleClose={handleMFAModalClose}
      onVerificationSuccess={handleMFAVerificationSuccess}
      email={mfaData.email}
      sendVerificationCode={authStore.sendVerificationCode}
      verifyCode={authStore.verifyCode}
    />
  );

  // SW2-2467: below 768px each project is one row that is itself the link (or, cross-tenant, a
  // button through the same handleRedirect). Same rows, routes and selection as the table below.
  if (isPhone) {
    // A sorted copy: the context array is shared with the desktop table and the search effect.
    const byName = (row) => (phoneSort === 'client' ? row.project.client.name : row.project.name) || '';
    const phoneRows = Array.isArray(displayStatsForMP)
      ? [...displayStatsForMP].sort((a, b) =>
          byName(a).localeCompare(byName(b), undefined, { sensitivity: 'base' }),
        )
      : displayStatsForMP;

    return (
      <>
        {isLoadingForMP ? (
          <Loading what='data' />
        ) : phoneRows && phoneRows.length ? (
          <ul className="my-projects-mobile__project-list">
            {phoneRows.map((ele, index) => {
              const body = (
                <>
                  <span className="my-projects-mobile__project-text">
                    <span className="my-projects-mobile__project-name">{ele.project.name}</span>
                    <span className="my-projects-mobile__project-client">{ele.project.client.name}</span>
                  </span>
                  <span className="my-projects-mobile__project-view" aria-hidden="true">View ›</span>
                </>
              );

              return (
                <li key={index} className="my-projects-mobile__project-row">
                  {selectMode && tenantFeatureContext.tenantHasFeature('Enable Route Planner') && (
                    <label className="my-projects-mobile__check">
                      <input
                        type="checkbox"
                        checked={Boolean(selectedProjects.find(selectedProject => selectedProject.id === ele.project_id))}
                        onChange={() => handleCheckboxChange(ele.project)}
                        disabled={
                          (selectedProjects.length === 10 && !selectedProjects.find(selectedProject => selectedProject.id === ele.project_id))
                        }
                      />
                      <span className="my-projects-mobile__sr-only">Select {ele.project.name}</span>
                    </label>
                  )}
                  {ele.division && ele.division.tenant_id === user.tenantId ? (
                    <Link
                      className="my-projects-mobile__project-link"
                      to={`/divisions/${ele.division.id}/projects/${ele.project_id}/inspections`}
                    >
                      {body}
                    </Link>
                  ) : (
                    <button
                      type="button"
                      className="my-projects-mobile__project-link"
                      onClick={() => handleRedirect(ele)}
                    >
                      {body}
                    </button>
                  )}
                </li>
              );
            })}
          </ul>
        ) : !Array.isArray(displayStatsForMP) ? (
          // A failed fetch leaves this undefined; say so rather than "No projects found".
          <p className="my-projects-mobile__empty" role="alert">
            Couldn&apos;t load your projects. Refresh the page to try again.
          </p>
        ) : (
          <p className="my-projects-mobile__empty">No projects found.</p>
        )}
        {mfaModal}
      </>
    );
  }

  return (
    <>
      <div className="projects-list">
        <div className="projects-list__content">
          <div className="projects-list__table-head">
            <h3 onClick={sortBySiteName}>Site Name <span><FontAwesomeIcon icon={faSort} /></span></h3>
            <h3 onClick={sortByClientName}>Client Name <span><FontAwesomeIcon icon={faSort} /></span></h3>
            <h3>Action</h3>
          </div>

          {!isLoadingForMP ?
            (displayStatsForMP && displayStatsForMP.map((ele, index) => {

              return (
                <div key={index} className="projects-list__table-body">
                {tenantFeatureContext.tenantHasFeature('Enable Route Planner') ?
                  <input
                    type="checkbox"
                    checked={selectedProjects.find(selectedProject=>selectedProject.id === ele.project_id)}
                    onChange={() => handleCheckboxChange(ele.project)}
                    disabled={
                      (selectedProjects.length ===10 && !selectedProjects.find(selectedProject=>selectedProject.id === ele.project_id))
                    }
                  />:<text></text>
                  }
                  <li> 
                  {ele.project.name}</li>
                  <li>{ele.project.client.name}</li>

                  {ele.division && ele.division.tenant_id === user.tenantId ? (
                    <li>
                      <Link
                        to={`/divisions/${ele.division.id}/projects/${ele.project_id}/inspections`}
                      >
                        <span>View Project</span>
                      </Link>
                    </li>
                  ) : (
                    <li>
                      <span onClick={() => handleRedirect(ele)}>View Project</span>
                    </li>
                  )}
                </div>
              );
            })
          ) : (
            <Loading what='data' />
          )}
        </div>
      </div>

      {mfaData && (
        <MFAVerificationModal
          show={showMFAModal}
          handleClose={handleMFAModalClose}
          onVerificationSuccess={handleMFAVerificationSuccess}
          email={mfaData.email}
          sendVerificationCode={authStore.sendVerificationCode}
          verifyCode={authStore.verifyCode}
        />
      )}
    </>
  );
};

export default ProjectList;
